import CustomTermsItem from "./CustomTermsItem.js";
import RegistrationPasswordField from "components/Reusable/Form/Reusable/RegistrationPasswordField.tsx";
import { EMAIL_VALIDATOR, mediumPassRegex } from "helpers/validators.js";

export const signupFields = {
  FirstName: {
    fieldKey: "FirstName",
    element: "input",
    type: "text",
    title: "FirstName",
    label: "signin-firstname-label",
    placeholder: "signin-firstname-placeholder",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
    containerClassName: "input-half-width",
  },
  LastName: {
    fieldKey: "LastName",
    element: "input",
    type: "text",
    title: "LastName",
    label: "signin-lastname-label",
    placeholder: "signin-lastname-placeholder",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
    containerClassName: "input-half-width",
  },
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "Email",
    label: "signin-email-label",
    placeholder: "signin-email-placeholder",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
  },
  Password: {
    fieldKey: "Password",
    element: "customelement",
    placeholder: "signin-password-placeholder",
    tooltip: {
      text: "signin-password-medium-tooltip-text",
    },
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: mediumPassRegex,
    },
    render: (props) => (
      <RegistrationPasswordField {...props} labelClassName="hidden" />
    ),
  },
  PasswordValidation: {
    fieldKey: "PasswordValidation",
    element: "input",
    type: "password",
    title: "PasswordValidation",
    label: "signin-password-validation-label",
    placeholder: "signin-password-validation-label",
    hidePassStrength: true,
    validation: {
      required: true,
      invalidMessage: "signin-password-tooltip-text",
      reg: /[^\n]+/,
    },
  },
  SubscribeToNewsletter: {
    fieldKey: "SubscribeToNewsletter",
    element: "checkbox",
    title: "SubscribeToNewsletter",
    label: "signin-subscribe-to-newsletter-label",
    className: "SigninCheckbox",
  },
  Terms: {
    fieldKey: "Terms",
    element: "checkbox",
    title: "Terms",
    label: "signin-terms-label",
    className: "SigninCheckbox",
    customTitleElement: CustomTermsItem,
    validation: {
      required: true,
      reg: true,
      invalidMessage: "default-input-invalid-message",
    },
  },
};
